export enum EmailMarketingSource {
    EMAIL_OCTOPUS = 'Email Octopus',
    MAILCHIMP = 'Mailchimp',
}
